module.exports = __webpack_public_path__ + "img/Restaurant12.63599a6f.png";